var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotificationOff32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.904 5a7.75 7.75 0 017.747 7.504l.003.246v4.508l.12.06c1.266.664 1.962 1.76 2.026 3.212l.004.22c0 1.154-.508 1.975-1.43 2.409l1.06 1.06a.75.75 0 01-.976 1.134l-.084-.073-18-18a.75.75 0 01.977-1.132l.084.072L9.54 8.326A7.742 7.742 0 0115.904 5zm-5.282 4.408l12.56 12.558c.814-.125 1.122-.492 1.122-1.216 0-1.149-.517-1.872-1.661-2.297a.75.75 0 01-.482-.6l-.007-.103v-5a6.25 6.25 0 00-11.532-3.342z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.904 12a.75.75 0 01.744.648l.006.102v5a.75.75 0 01-.489.703C8.02 18.88 7.5 19.602 7.5 20.75c0 .768.347 1.135 1.232 1.234l.172.016h4a.75.75 0 01.75.75c0 1.585.665 2.249 2.25 2.249 1.586 0 2.25-.664 2.25-2.249a.75.75 0 111.5 0c0 2.413-1.335 3.749-3.75 3.749-2.102 0-3.387-1.013-3.684-2.87l-.018-.129-3.349-.002c-1.739-.119-2.771-1.02-2.848-2.56L6 20.75c0-1.562.702-2.735 2.034-3.433l.12-.06V12.75a.75.75 0 01.649-.743L8.904 12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationOff32);
export default __webpack_public_path__ + "static/media/icon-notification-off-32.4c472675.svg";
export { ForwardRef as ReactComponent };